
const LoadingScreen = () => {
    return <div className="loading-container">
        <img src="/assets/lp_loader.gif" alt="" />
    </div>;
}
export default LoadingScreen;